/**
 * Pure helpers for the AccountDetail Overview tab's Classic | Grid view (v1.5.75).
 *
 * The grid view's Projects card exposes ONE dropdown (Open / Open + Future / All)
 * that must drive the SAME two booleans the classic layout's toggle buttons use
 * (`showAllProjects` / `showFutureProjects`), so the `?openProject` deep-link
 * reveal effect and the client-change reset keep working without knowing which
 * view is showing. These two functions are that mapping, in both directions.
 */

export type ProjectsFilter = "open" | "open_future" | "all";

export function projectsFilterFromFlags(showAll: boolean, showFuture: boolean): ProjectsFilter {
  if (showAll) return "all";
  if (showFuture) return "open_future";
  return "open";
}

export function flagsFromProjectsFilter(value: ProjectsFilter): { showAll: boolean; showFuture: boolean } {
  switch (value) {
    case "all":
      return { showAll: true, showFuture: false };
    case "open_future":
      return { showAll: false, showFuture: true };
    default:
      return { showAll: false, showFuture: false };
  }
}

/** Portal-activity uploads only (no comments), newest first. Stable, non-mutating. */
export function recentPortalUploads<T extends { type: string; created_at: string }>(items: T[]): T[] {
  return items
    .filter((i) => i.type === "upload")
    .map((item, index) => ({ item, index, t: new Date(item.created_at).getTime() }))
    .sort((a, b) => (b.t - a.t) || (a.index - b.index))
    .map((x) => x.item);
}

export type AccountOverviewView = "classic" | "grid";

/** localStorage parse for the view pref — anything but the exact "grid" is classic. */
export function parseAccountOverviewView(raw: string | null | undefined): AccountOverviewView {
  return raw === "grid" ? "grid" : "classic";
}
